/**
 * Whether a user-supplied string is an absolute http/https URL.
 *
 * Mirrors the server-side guard in FeedItemLink.NormalizeUrl. Values that pass are rendered as
 * clickable anchors, so schemes other than http/https (notably `javascript:` and `data:`) must
 * be rejected — the server enforces this too, this is only to fail fast in the form.
 */
export function isValidHttpUrl(value: string): boolean {
  const trimmed = value.trim();
  if (!trimmed) return false;

  let parsed: URL;
  try {
    parsed = new URL(trimmed);
  } catch {
    return false;
  }

  return parsed.protocol === 'http:' || parsed.protocol === 'https:';
}
